import { usePrivacyText } from '@itarget/shared'
import { Box, Chip, Icon, Typography } from '@material-ui/core'
import { useStyles } from './useStyles'
import { useTransaction } from './useTransaction'

const Transaction = ({
  status,
  points,
  modality,
  description,
  transactionDate,
  transactionType,
  canUsePrivacy = false,
}) => {
  const [date, time] = transactionDate.split(' ')
  const { getPrivacyText } = usePrivacyText()
  const {
    getDate,
    getHour,
    getTransactionSymbol,
    getDataTransactionType,
    getTransactionTypeLabel,
    getTransactionStatusLabel,
    getTransactionModalityLabel,
  } = useTransaction()
  const pointsLabel = `${getTransactionSymbol(transactionType)}${points}`
  const privacyPoints = canUsePrivacy ? getPrivacyText(pointsLabel) : null
  const classes = useStyles()
  return (
    <Box className={classes.consolidationContainer}>
      <Icon
        data-transaction-type={getDataTransactionType(transactionType)}
        className={classes.movementsIcon}
      >
        attach_money
      </Icon>

      <Box flex={1} className={classes.verticalContainer}>
        <Typography className={classes.type}>
          {getTransactionTypeLabel(transactionType)} (
          {getTransactionStatusLabel(status)})
        </Typography>

        <Typography className={classes.description}>{description}</Typography>
      </Box>

      <Box className={classes.verticalContainer}>
        <Typography className={classes.date}>{getDate(date)}</Typography>

        <Typography className={classes.hour}>{getHour(time)}</Typography>
      </Box>

      <Box alignItems="flex-end" className={classes.verticalContainer}>
        <Chip
          data-modality={modality}
          label={getTransactionModalityLabel(modality)}
          className={classes.chip}
        />

        <Typography className={classes.amount}>
          {privacyPoints || pointsLabel}
        </Typography>
      </Box>
    </Box>
  )
}

export default Transaction
